import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionOwnersVariables = Types.Exact<{
  contractSlug: Types.Scalars['citext'];
  currentUserPublicKey: Types.Scalars['String'];
  limit: Types.Scalars['Int'];
  offset: Types.Scalars['Int'];
}>;


export type CollectionOwners = { items: Array<(
    Pick<Types.User, 'name' | 'username' | 'profileImageUrl' | 'publicKey'>
    & { isFollowingUser: { aggregate: Types.Maybe<Pick<Types.Follow_Aggregate_Fields, 'count'>> } }
  )> };



export const CollectionOwnersDocument = /*#__PURE__*/ `
    query CollectionOwners($contractSlug: citext!, $currentUserPublicKey: String!, $limit: Int!, $offset: Int!) {
  items: user(
    limit: $limit
    offset: $offset
    where: {ownedArtworks: {collection: {slug: {_eq: $contractSlug}}, deletedAt: {_is_null: true}, hiddenAt: {_is_null: true}, isIndexed: {_eq: true}, tokenId: {_is_null: false}}}
  ) {
    name
    username
    profileImageUrl
    publicKey
    isFollowingUser: follows_aggregate(
      where: {user: {_eq: $currentUserPublicKey}, isFollowing: {_eq: true}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

export const useCollectionOwners = <
      TData = CollectionOwners,
      TError = ClientError
    >(
      variables: CollectionOwnersVariables,
      options?: Omit<UseQueryOptions<CollectionOwners, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionOwners, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionOwners, TError, TData>(
      {
    queryKey: ['CollectionOwners', variables],
    queryFn: hasuraFetcher<CollectionOwners, CollectionOwnersVariables>(CollectionOwnersDocument, variables),
    ...options
  }
    )};

useCollectionOwners.getKey = (variables: CollectionOwnersVariables) => ['CollectionOwners', variables];

export const useInfiniteCollectionOwners = <
      TData = InfiniteData<CollectionOwners>,
      TError = ClientError
    >(
      variables: CollectionOwnersVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionOwners, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionOwners, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionOwners, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionOwners.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionOwners, CollectionOwnersVariables>(CollectionOwnersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionOwners.getKey = (variables: CollectionOwnersVariables) => ['CollectionOwners.infinite', variables];


useCollectionOwners.fetcher = (variables: CollectionOwnersVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionOwners, CollectionOwnersVariables>(CollectionOwnersDocument, variables, options);
